module.exports = __webpack_public_path__ + "img/refer-illustration.0ee4c2ba.png";